import { render, staticRenderFns } from "./ServerErrorSvg.vue?vue&type=template&id=4b006e1f&"
import script from "./ServerErrorSvg.vue?vue&type=script&lang=ts&"
export * from "./ServerErrorSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports